import Guide from '@/containers/guide/Guide';

import { ROUTE_GUIDE } from './names';

export default [
    {
        path: '/guide/:openid',
        name: ROUTE_GUIDE,
        component: Guide,
        meta: {
            title: '邀请加入私教约课系统',
        },
    },
];



// WEBPACK FOOTER //
// ./src/router/guide.js